export const helpyTypes = [
  {
    name: 'Default',
    value: 1,
  },
  {
    name: 'Hint',
    value: 2,
  },
  {
    name: 'TourGuide',
    value: 3,
  },
]
